<template>
  <div>
    <header id="header" class="header">
      <div class="main-header">
        <div class="inner">
          <div class="flexbetween">
            <!-- Logo -->
            <div><a class="rslogo" @click="clickLogo()"><img src="static/images/icon/header/logo.png"/></a></div>
            <!-- contentname -->
            <div v-if="!isDocomo(platformName) && !isAu(platformName)" class="contentname lbold font32">{{ viewName }}</div>

            <div class="settings">
              <div class="item setting-help">
                <popover name="help" :closeOnContentClick="true">
                  <div class="btn-help" @click="updateMenu()" slot="face"><img src="static/images/icon/header/help.png"></div>
                  <div class="help-content" slot="content">
                    <ul v-if="isDocomo(platformName) || isAu(platformName)">
                      <li class="docomo_push">
                        <div><span>プッシュ通知を許可</span><span class="push_option" :class="{ active: isPushEnabled }" @click="showPushSetting">ON</span><span class="push_option" :class="{ active: !isPushEnabled }" @click="showPushSetting">OFF</span></div>
                        <div v-if="isDocomo(platformName)" class="font14 lbold ml10 mt10">月に1~3回程度アップデート案内します。</div>
                        <div v-if="isDocomo(platformName)" class="font14 ml10"><span>らくらくスマートフォン等の非対応機種では配信されません。</span></div>
                      </li>
                      <li v-if="isDocomo(platformName)" @click="showPrivacyPolicy">プライバシーポリシー</li>
                      <li v-if="isAu(platformName)" @click="showTakeOver()">引継ぎコード発行</li>
                      <li v-if="isAu(platformName)"><a :href="getContactUrl()" target="_blank">お問い合わせ</a></li>
                      <li v-if="isAu(platformName)"><a href="http://www.sourcenext.com/r/p/au/rosetta_us/support/" target="_blank">FAQ</a></li>
                      <li v-if="isAu(platformName)"><a href="http://www.sourcenext.com/r/p/au/rosetta_us/product/" target="_blank">製品紹介</a></li>
                      <li v-if="currentView != 'PortalList' && currentView != 'AuPortalList'" @click="clickLogo()">戻る</li>
                    </ul>
                    <ul v-else>
                      <li v-show="!isPlatformiOS(platformName)"><a class="logout-btn" @click="showLogout()">ログアウト</a></li>
                      <li v-if="isPushSetting" class="docomo_push">
                        <div><span>プッシュ通知を許可</span><span class="push_option" :class="{ active: isPushEnabled }" @click="showPushSetting">ON</span><span class="push_option" :class="{ active: !isPushEnabled }" @click="showPushSetting">OFF</span></div>
                      </li>
                      <li @click="sendGaEventHelpClick(constants.GA_EVENT.LABEL.SUPPORT)"><a href="http://www.sourcenext.com/support/t/p/?c=19e4d5e1-c20d-4665-90c5-8e47ed771d46" target="_blank" class="helptext">サポート</a></li>
                      <li><a href="https://www.sourcenext.com/r/p/rosettastone/eula/" target="_blank" class="readme">Rosetta Stone について</a></li>
                      <li v-show="isPlatformiOS(platformName)" @click="doRestoreContent()"><a>購入を復元する</a></li>
                      <li v-if="!isRegistered" v-show="isPlatformiOS(platformName)" @click="doRegisterUser()"><a>PCや別の端末と連携する</a></li>
                      <li v-else v-show="isPlatformiOS(platformName)" @click="doUnregisterUser()"><a>PCや別の端末との連携を解除する</a></li>
                      <li v-if="isPlatformiOS(platformName) || isLibraryAndroid(platformName)"><a href="https://www.sourcenext.com/support/form/InquiryForm0512" target="_blank" class="userdell">アカウント削除</a></li>
                    </ul>
                  </div>
                </popover>
              </div>
              <!-- メニュー -->
              <!-- <div class="item sp-bars">
                <popover name="menu" :closeOnContentClick="true">
                  <div class="btn-menu" slot="face"><img src="static/images/icon/header/menu.png"></div>
                  <div id="spNav" class="navigation" slot="content">
                    <ul>
                      <li><a @click="$emit('changeView', 'PurchasedList')">学習</a></li>
                      <li><a @click="$emit('changeView', 'StoreList')">ストア</a></li>
                      <li v-if="isMenuVisible"><a>学習状況</a></li>
                      <li v-if="isMenuVisible"><a>単語帳</a></li>
                      <li v-if="isMenuVisible"><a>辞書</a></li>
                      <li v-if="isMenuVisible"><a>設定</a></li>
                    </ul>
                  </div>
                </popover>
              </div> -->
            </div><!-- settings -->
          </div><!-- flexbetween -->
        </div><!-- inner -->
      </div><!-- main-header -->

      <nav id="pcNav" class="navigation">
        <ul>
          <li :class="{ 'current-page': $parent.currentView == 'PurchasedList' || $parent.currentView == 'PurchasedDetail' }">
            <a @click="showLearning()">学習</a>
          </li>
          <!-- ポップアップ辞書機能クローズのため辞書リンクをコメントアウト -->
          <!-- <li v-if="isMenuVisible" class="">
            <a @click="doDictionary()">辞書</a>
          </li> -->
          <!--
          <li :class="{ 'current-page': $parent.currentView == 'StoreList' || $parent.currentView == 'StoreDetail' }">
            <a @click="showStore()">ストア</a>
          </li>
          -->
          <!-- <li v-if="isMenuVisible"><a>学習状況</a></li>
          <li v-if="isMenuVisible"><a>単語帳</a></li>
          <li v-if="isMenuVisible"><a>設定</a></li> -->
        </ul>
      </nav>
    </header><!-- header -->

    <div v-if="!isDocomo(platformName) && !isAu(platformName)" class="sp-second-header">
      <div class="items">
        <div>
          <div class="studylink" @click="showLearning()">
            <img src="static/images/icon/header/icon-study.png">
            <span>学習</span>
          </div>
        </div>
      </div>
      <!-- ポップアップ辞書機能クローズのため辞書リンクをコメントアウト -->
      <!-- <div class="items">
        <div>
          <div v-if="isMenuVisible" @click="doDictionary()" class="library">
            <img src="static/images/icon/header/icon_dic.png">
            <span>辞書</span>
          </div>
        </div>
      </div> -->
      <!-- <div class="items">
        <div>
          <div class="storelink" @click="showStore()">
            <img src="static/images/icon/header/icon-store.png">
            <span>ストア</span>
          </div>
        </div>
      </div> -->
    </div>

    <!-- ログアウト画面 -->
    <Logout v-if="isLogoutVisible" @close="isLogoutVisible = false" />

    <!-- 引継ぎコード発行画面 -->
    <TakeOver v-if="isTakeOverVisible" @close="closeTakeOver()" />
  </div>
</template>

<script>
import popover from "vue-popover";
import Logout from "@/components/Logout";
import TakeOver from "@/components/TakeOver";
import common from "@/mixin/common";
import * as constants from "@/mixin/constants";

const URL_BIND_STRING_VERSION = "{VERSION}";
const URL_CONTACT_AU = "https://www.sourcenext.com/faq/cgi-bin/Inquiry002_J.cgi?type=%a5%ed%a5%bc%a5%c3%a5%bf%a5%b9%a5%c8%a1%bc%a5%f3%b1%d1%b8%ec&ver=" + URL_BIND_STRING_VERSION + "au";

export default {
  name: "toolbar",
  props: {
    viewName: String,
    isMenuVisible: Boolean,
    platformName: String,
    currentView: String,
    isRegistered: Boolean
  },
  data: function() {
    return {
      // ログアウト画面表示
      isLogoutVisible: false,
      // プッシュ通知許可
      isPushEnabled: false,
      // 引継ぎコード発行画面表示
      isTakeOverVisible: false,
      // プッシュ通知項目の表示
      isPushSetting: false
    };
  },
  computed: {
    constants: function() {
      return constants;
    }
  },
  components: {
    popover,
    Logout,
    TakeOver
  },
  mixins: [
    common
  ],
  methods: {
    /**
     * メニュー表示の更新
     */
    updateMenu: function() {
      this.log("Toolbar start updateMenu");

      // GoogleAnalyticsイベントヒット送信
      this.sendGaEventHeaderClick(constants.GA_EVENT.LABEL.HELP);

      const self = this;
      if (!this.isEnvironmentPc()) {
        new Promise(function(resolve, reject) {
          if (self.isPlatformiOS(self.platformName)) {
            // iOSの場合
            const promiseId = storage_wrapper.getPromiseId();
            handlers[promiseId] = { resolve: resolve, reject: reject };
            try {
              window.Phone.GetPushSetting(promiseId);
            } catch (err) {
              self.log("Toolbar GetPushSetting Error: " + err);
              reject();
            }
            
          } else {
            // Androidの場合
            try {
              const result = window.Phone.GetPushSetting();
              resolve(result);
            } catch (err) {
              self.log("Toolbar GetPushSetting Error: " + err);
              reject();
            }
          }
        }).then(function(pushSetting) {
          self.isPushSetting = true;
          self.isPushEnabled = pushSetting == 1;
        }).catch(function() {
          // プッシュ通知許可有無取得メソッドがないバージョンのアプリの場合
          self.isPushSetting = false;
        });
      }
    },
    /**
     * プッシュ通知設定変更
     */
    showPushSetting: function() {
      this.log("Toolbar start showPushSetting");

      // 通知設定ダイアログの表示
      window.Phone.ShowPushSetting();
    },
    /**
     * プライバシーポリシー表示
     */
    showPrivacyPolicy: function() {
      this.log("Toolbar start showPrivacyPolicy");

      // プライバシーポリシー画面の表示
      window.Phone.ShowPrivacyPolicy();
    },
    /**
     * コンテンツ復元処理の実行
     */
    doRestoreContent: function() {
      this.log("Toolbar start RestoreContent");

      // GoogleAnalyticsイベントヒット送信
      this.sendGaEventHelpClick(constants.GA_EVENT.LABEL.RESTORE);

      // モバイルアプリのコンテンツ復元処理メソッドを実行
      window.Phone.RestoreContent();
    },
    /**
     * ユーザ登録処理の実行
     */
    doRegisterUser: function() {
      this.log("Toolbar start doRegisterUser");

      // GoogleAnalyticsイベントヒット送信
      this.sendGaEventHelpClick(constants.GA_EVENT.LABEL.REGISTER_USER);

      // ログイン画面の表示
      this.$emit("changeView", "Login");
    },
    /**
     * ユーザ登録解除処理の実行
     */
    doUnregisterUser: function() {
      this.log("Toolbar start doUnregisterUser");

      // GoogleAnalyticsイベントヒット送信
      this.sendGaEventHelpClick(constants.GA_EVENT.LABEL.UNREGISTER_USER);

      // モバイルアプリのユーザ登録解除処理メソッドを実行
      window.Phone.UnregisterUser();
    },
    /**
     * 辞書画面を表示
     */
    doDictionary: function() {
      this.log("Toolbar start doDictionary");

      // GoogleAnalyticsイベントヒット送信
      this.sendGaEventHeaderClick(constants.GA_EVENT.LABEL.DICTIONARY);

      if (this.isEnvironmentPc()) {
        var url = location.href + "dictionary";
        window.open(url, "_blank", "width=980,height=800,resizable=yes,scrollbars=yes");
      } else {
        this.$emit("showDictionary");
      }
    },
    /**
     * ロゴ押下時の処理
     */
    clickLogo: function() {
      var view = "PurchasedList";

      if (this.isDocomo(this.platformName)) {
        view = "PortalList";
      } else if (this.isAu(this.platformName)) {
        view = "AuPortalList";
      }

      this.$emit("changeView", view);
    },
    /**
     * お問い合わせ画面のURLを取得する
     *
     * @return {String} お問い合わせ画面URL
     */
    getContactUrl: function() {
      this.log("Toolbar start getContactUrl");
      var versionName = window.Phone.GetVersionName();
      var url = URL_CONTACT_AU.replace(URL_BIND_STRING_VERSION, versionName);
      this.log("Toolbar getContactUrl result:" + url);
      return url;
    },
    /**
     * 引継ぎコード発行画面を表示する
     */
    showTakeOver: function() {
      this.log("Toolbar start showTakeOver");

      this.isTakeOverVisible = true;
    },
    /**
     * 引継ぎコード発行画面を閉じる
     */
    closeTakeOver: function() {
      this.log("Toolbar start closeTakeOver");

      this.isTakeOverVisible = false;
    },
    /**
     * 学習画面表示
     */
    showLearning: function() {
      this.log("Toolbar start showLearning");
      // GoogleAnalyticsイベントヒット送信
      this.sendGaEventHeaderClick(constants.GA_EVENT.LABEL.LEARNING);
      // 学習画面表示
      this.$emit("changeView", "PurchasedList");
    },
    /**
     * ストア画面表示
     */
    showStore: function() {
      this.log("Toolbar start showStore");
      // GoogleAnalyticsイベントヒット送信
      this.sendGaEventHeaderClick(constants.GA_EVENT.LABEL.STORE);
      // ストア画面表示
      this.$emit("changeView", "StoreList");
    },
    /**
     * ログアウト画面表示
     */
    showLogout: function() {
      this.log("Toolbar start showLogout");
      // GoogleAnalyticsイベントヒット送信
      this.sendGaEventHelpClick(constants.GA_EVENT.LABEL.LOGOUT);
      // ログアウト画面表示
      this.isLogoutVisible = true;
    },
    /**
     * GoogleAnalyticsヘッダ部クリックイベントヒット送信
     *
     * @param {String} eventLabel イベントラベル
     */
    sendGaEventHeaderClick: function(eventLabel) {
      this.sendGaEventClick(constants.GA_EVENT.GATEGORY.HEADER, eventLabel);
    },
    /**
     * GoogleAnalyticsヘルプメニュークリックイベントヒット送信
     *
     * @param {String} eventLabel イベントラベル
     */
    sendGaEventHelpClick: function(eventLabel) {
      this.sendGaEventClick(constants.GA_EVENT.GATEGORY.HELP, eventLabel);
    },
    /**
     * GoogleAnalyticsクリックイベントヒット送信
     *
     * @param {String} eventCategory イベントカテゴリ
     * @param {String} eventLabel イベントラベル
     */
    sendGaEventClick: function(eventCategory, eventLabel) {
      rosettaGA.sendEvent(
        this.getGaEventCategoryByPlatformName(eventCategory, this.platformName),
        constants.GA_EVENT.ACTION.CLICK,
        eventLabel
      );
    }
  }
};
</script>

<style lang="scss">
@import "src/assets/style/header";
</style>



// WEBPACK FOOTER //
// Toolbar.vue?0613e6a5